import React, { useEffect, useState } from "react";
import { PermissionButton } from "./permission-button";
import DefaultPermissionsIcon from "../../assets/icons/user-access-icons/default-permissions-icon";
import AllowedAccess from "../../guards/AllowedAccess";
import PermissionList from "../../guards/PermissionList";
import DefaultPermissionsOpenIcon from "../../assets/icons/user-access-icons/default-permissions-open-icon";

const PermissionsPanel = ({ data }) => {
  const [permissions, setPermissions] = useState(data.slice(1));
  const [openSections, setOpenSections] = useState({}); // For collapsible toggles

  // Toggle parent and all its children
  const toggleParent = (index) => {
    const updated = [...permissions];
    const parent = updated[index];
    const newVal = !parent.isEnabled;
    parent.isEnabled = newVal;
    parent.children.forEach((child) => (child.isEnabled = newVal));
    setPermissions(updated);
  };

  //  Improved toggleChild with auto-enable rules map of only "Trials View" permissions
  // const toggleChild = (parentIndex, childIndex) => {
  //   const updated = [...permissions];
  //   const parent = updated[parentIndex];
  //   const child = parent.children[childIndex];

  //   // Toggle the clicked child
  //   child.isEnabled = !child.isEnabled;

  //   // ✅ List of actions that should auto-enable "Trial View"
  //   const autoEnableTrialsViewList = [
  //     "Edit Trial",
  //     "Export Trial Data",
  //     "Call Trial Patient",
  //     "Chat with Trial Patient",
  //     "ReRoute Trial Patient",
  //     "Assign Trial Patient",
  //     "Delete Trial Patient",
  //     "View Trial Patient",
  //   ];
  //   const autoEnablePatientViewList = ["Edit Patient", "Export Patient Data"];
  //   const autoEnableLocationViewList = [
  //     "Edit Location",
  //     "Export Location Data",
  //   ];
  //   const autoEnableRecriuterViewList = ["Edit Recruiter", "Export Recruiter"];

  //   // ✅ Auto-enable "Trial View" if one of the above actions is enabled
  //   if (
  //     autoEnableTrialsViewList.includes(child.childPageName) &&
  //     child.isEnabled
  //   ) {
  //     const viewTrialChild = parent.children.find(
  //       (c) => c.childPageName === "Trial View"
  //     );
  //     if (viewTrialChild && !viewTrialChild.isEnabled) {
  //       viewTrialChild.isEnabled = true;
  //     }
  //   }

  //   // ✅ If all children are enabled → enable parent
  //   const allChildrenEnabled = parent.children.every((c) => c.isEnabled);
  //   if (allChildrenEnabled) {
  //     parent.isEnabled = true;
  //   }

  //   // ❌ If any child is disabled, do NOT disable the parent automatically
  //   setPermissions(updated);
  // };

  // Improved toggleChild with auto-enable rules map of only "View" permissions

  const toggleChild = (parentIndex, childIndex) => {
    const updated = [...permissions];
    const parent = updated[parentIndex];
    const child = parent.children[childIndex];

    // Toggle the clicked child
    child.isEnabled = !child.isEnabled;

    // ✅ Map of auto-enable rules
    const autoEnableRules = {
      "Trial View": [
        "Add Trial",
        "Edit Trial",
        "Export Trial Data",
        "Call Trial Patient",
        "Chat with Trial Patient",
        "ReRoute Trial Patient",
        "Assign Trial Patient",
        "Delete Trial Patient",
        "View Trial Patient",
      ],
      "View Patient": ["Add Patient", "Edit Patient", "Export Patient Data"],
      "View Location": [
        "Add Location",
        "Edit Location",
        "Export Location Data",
      ],
      "View Recruiter": ["Add Recruiter", "Edit Recruiter", "Export Recruiter"],
      "View Patient Conversations": [
        "Outbound Conversation",
        "Conversation Note",
        "Add Event to Conversation",
        "Chat Details",
      ],
      "My Calendar": ["Filter Calendar", "Calendar View Type"],
    };

    // ✅ Find matching view permission and enable it if required
    Object.entries(autoEnableRules).forEach(([viewName, dependencyList]) => {
      if (dependencyList.includes(child.childPageName) && child.isEnabled) {
        const viewChild = parent.children.find(
          (c) => c.childPageName === viewName
        );
        if (viewChild && !viewChild.isEnabled) {
          viewChild.isEnabled = true;
        }
      }
    });

    // ✅ If all children are enabled → enable parent
    const allChildrenEnabled = parent.children.every((c) => c.isEnabled);
    if (allChildrenEnabled) {
      parent.isEnabled = true;
    }

    // ❌ Don’t disable parent automatically when any child is turned off
    setPermissions(updated);
  };

  // // Improved toggleChild with auto-enable rules map of only "Add & View" permissions
  // const toggleChild = (parentIndex, childIndex) => {
  //   const updated = [...permissions];
  //   const parent = updated[parentIndex];
  //   const child = parent.children[childIndex];

  //   // Toggle the clicked child
  //   child.isEnabled = !child.isEnabled;

  //   // ✅ Map of auto-enable rules (now enables both View + Add)
  //   const autoEnableRules = {
  //     "Trial View": [
  //       "Edit Trial",
  //       "Export Trial Data",
  //       "Call Trial Patient",
  //       "Chat with Trial Patient",
  //       "ReRoute Trial Patient",
  //       "Assign Trial Patient",
  //       "Delete Trial Patient",
  //       "View Trial Patient",
  //     ],
  //     "Add Trial": [
  //       "Edit Trial",
  //       "Export Trial Data",
  //       "Call Trial Patient",
  //       "Chat with Trial Patient",
  //       "ReRoute Trial Patient",
  //       "Assign Trial Patient",
  //       "Delete Trial Patient",
  //       "View Trial Patient",
  //     ],

  //     "View Patient": ["Edit Patient", "Export Patient Data"],
  //     "Add Patient": ["Edit Patient", "Export Patient Data"],

  //     "View Location": ["Edit Location", "Export Location Data"],
  //     "Add Location": ["Edit Location", "Export Location Data"],

  //     "View Recruiter": ["Edit Recruiter", "Export Recruiter"],
  //     "Add Recruiter": ["Edit Recruiter", "Export Recruiter"],
  //   };

  //   // ✅ Auto-enable both "View" and "Add" if a dependent action is enabled
  //   Object.entries(autoEnableRules).forEach(([targetName, dependencyList]) => {
  //     if (dependencyList.includes(child.childPageName) && child.isEnabled) {
  //       const targetChild = parent.children.find(
  //         (c) => c.childPageName === targetName
  //       );
  //       if (targetChild && !targetChild.isEnabled) {
  //         targetChild.isEnabled = true;
  //       }
  //     }
  //   });

  //   // ✅ Add “Meta Integration Ad” permission dynamically under Trials (if not exists)
  //   if (parent.name === "Trials") {
  //     const editTrial = parent.children.find(
  //       (c) => c.childPageName === "Edit Trial"
  //     );
  //     if (editTrial) {
  //       const metaIntegrationAd = parent.children.find(
  //         (c) => c.childPageName === "Meta Integration Ad"
  //       );
  //       if (!metaIntegrationAd) {
  //         parent.children.push({
  //           childPageName: "Meta Integration Ad",
  //           isEnabled: false,
  //         });
  //       }
  //     }
  //   }

  //   // ✅ If all children are enabled → enable parent
  //   const allChildrenEnabled = parent.children.every((c) => c.isEnabled);
  //   if (allChildrenEnabled) {
  //     parent.isEnabled = true;
  //   }

  //   // ❌ Don’t disable parent automatically when any child is turned off
  //   setPermissions(updated);
  // };

  // Toggle section collapse
  const toggleSection = (id) => {
    setOpenSections((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  useEffect(() => {
    console.log("permissions", permissions);
  }, [permissions]);

  return (
    <div className="h-[calc(100vh_-_320px)] overflow-y-auto pr-2 space-y-5 p-4">
      {permissions &&
        permissions.length &&
        permissions.map((section, i) => (
          <div key={section.parentPageId} className="border rounded-md">
            <div
              className={`flex items-center justify-between px-4 py-3 cursor-pointer`}
            >
              <div
                className={`flex items-center justify-between py-1 w-full ${
                  openSections[section.parentPageId] ? "border-b pb-4" : ""
                }`}
              >
                <div
                  className="flex items-center gap-2"
                  onClick={() => toggleSection(section.parentPageId)}
                >
                  {openSections[section.parentPageId] ? (
                    <DefaultPermissionsOpenIcon size={14} />
                  ) : (
                    <DefaultPermissionsIcon size={14} />
                  )}
                  <span className="font-medium text-[#1B2A3D]">
                    {section.pageName}
                  </span>
                </div>

                {/* Parent Toggle */}
                <AllowedAccess
                  permissions={[
                    PermissionList.admin_userAccess.edit_permissions,
                  ]}
                  mode="readonly"
                >
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={section.isEnabled}
                      onChange={() => toggleParent(i)}
                      className="sr-only peer"
                    />
                    <div
                      className={`w-[38px] h-[20px] rounded-full transition-colors duration-300 ${
                        section.isEnabled
                          ? "bg-[#245CEA]"
                          : "bg-[white] border border-[#87909E]"
                      }`}
                    >
                      <div
                        className={`absolute top-[2px] left-[2px] h-[16px] w-[16px] rounded-full transition-transform duration-300 ${
                          section.isEnabled
                            ? "translate-x-[18px] bg-white"
                            : "translate-x-0 bg-[#87909E]"
                        }`}
                      />
                    </div>
                  </label>
                </AllowedAccess>
              </div>
            </div>

            {/* Children Buttons */}

            {openSections[section.parentPageId] && (
              <div className="p-3 space-y-2">
                {section.children.map((child, j) => (
                  <PermissionButton
                    key={child.childPageId}
                    label={child.childPageName}
                    enabled={child.isEnabled}
                    disabled={!section.isEnabled} // Disable child if parent is not enabled
                    setEnabled={() => toggleChild(i, j)}
                  />
                ))}
              </div>
            )}
          </div>
        ))}
    </div>
  );
};

export default PermissionsPanel;
